import {Box, Button, Flex, Icon, Image, Text} from '@chakra-ui/react'
import AvatarSummary from '@assets/images/paraphrase/avatar_summary.png'
import {CommonColors} from '@utils/CommonStyles'
import {useDispatch, useSelector} from 'react-redux'
import {ReactComponent as SaveTrueIcon} from '@assets/svgs/save_true.svg'
import {ReactComponent as SaveFalseIcon} from '@assets/svgs/save_false.svg'
import {useEffect, useState} from 'react'
import {
  updateIsShowSavePhraseForm,
  updatePhraseToSave,
} from '@redux/shared/shared'
import SavePhraseForm from '@components/SavePhraseForm'
import {updateIsFinish} from '@redux/paraphrase/paraphraseSlice'

const Summary = () => {
  const {paraphraseData} = useSelector((state: any) => state.paraphrase)
  const {phraseToSave} = useSelector((state: any) => state.shared)

  const [isSave, setIsSave] = useState<any>({})
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateIsFinish(true))
  }, [])

  const handleSavePhrase = async (item: any) => {
    dispatch(updateIsShowSavePhraseForm(true))
    dispatch(updatePhraseToSave(item.phrase))
  }

  const handleAfterSuccess = () => {
    setIsSave((pre: any) => ({
      ...pre,
      [phraseToSave.replace(/ /g, '_')]: true,
    }))
  }

  return (
    <Flex
      h={'100%'}
      bg={'#fff'}
      p={{base: '16px', md: '32px'}}
      borderRadius={'24px'}
      flexDirection={{base: 'column', md: 'row'}}>
      <Flex
        alignItems={{base: 'center', md: 'start'}}
        gap={{base: '16px', md: '32px'}}
        flex={1}
        overflow={'auto'}
        flexDirection={{base: 'column', md: 'row'}}>
        <Image
          src={AvatarSummary}
          alt="avatar-summary"
          w={{base: '100px', md: '270px'}}
          objectFit={'contain'}
        />
        <Flex flexDirection={'column'} flex={1} w={'100%'}>
          <Flex
            justifyContent={'space-between'}
            border={'2px solid #BCE4FF'}
            borderRadius={'20px'}
            p={{base: '16px', md: '20px'}}
            bg={'#EEF8FF'}>
            <Box>
              <Text
                fontSize={{base: '14px', md: '16px'}}
                color={CommonColors.primary}>
                Câu đã Paraphrase
              </Text>
              <Text
                fontSize={{base: '16px', md: '20px'}}
                fontWeight={'500'}
                mt={'12px'}>
                {paraphraseData?.summary?.paraphrased_sentence?.sentence}
              </Text>
              <Text
                fontSize={{base: '14px', md: '16px'}}
                color={CommonColors.primary}
                mt={'24px'}>
                Câu gốc
              </Text>
              <Text fontSize={{base: '14px', md: '16px'}} mt={'12px'}>
                {paraphraseData?.summary?.original_sentence}
              </Text>
            </Box>
          </Flex>

          <Flex
            flexDirection={'column'}
            p={{base: '16px', md: '20px'}}
            border={'1px solid #BCE4FF'}
            borderRadius={'20px'}
            mt={'24px'}>
            <Text
              fontSize={{base: '14px', md: '16px'}}
              color={CommonColors.primary}>
              Từ đồng nghĩa
            </Text>
            {paraphraseData?.summary?.words?.map((word: any, index: number) => (
              <Flex
                key={index}
                justifyContent={'space-between'}
                alignItems={'end'}
                py={'16px'}
                flexDirection={{base: 'row', sm: 'row'}}
                gap={{base: '12px', sm: '0'}}
                pb={
                  index < paraphraseData?.summary?.words?.length - 1
                    ? '16px'
                    : '0'
                }
                borderBottom={
                  index < paraphraseData?.summary?.words?.length - 1
                    ? '1px solid #E4E7EC'
                    : 'none'
                }>
                <Box>
                  <Text fontSize={{base: '14px', md: '16px'}}>
                    {word?.phrase}
                  </Text>
                  <Text
                    mt={'8px'}
                    color={'#85888E'}
                    fontSize={{base: '14px', md: '16px'}}>
                    {word?.phrase_vi}
                  </Text>
                </Box>
                <Button
                  borderColor={'#70BAFF'}
                  variant="outline"
                  color={CommonColors.primary}
                  bg={
                    isSave[word?.phrase.replace(/ /g, '_')] || word?.is_saved
                      ? '#D6EBFF'
                      : 'unset'
                  }
                  leftIcon={
                    <Icon
                      as={
                        isSave[word?.phrase.replace(/ /g, '_')] ||
                        word?.is_saved
                          ? SaveTrueIcon
                          : SaveFalseIcon
                      }
                      w={'20px'}
                      h={'20px'}
                    />
                  }
                  onClick={() => handleSavePhrase(word)}
                  fontSize={{base: '14px', md: '16px'}}>
                  {isSave[word?.phrase.replace(/ /g, '_')] || word?.is_saved
                    ? 'Đã lưu'
                    : 'Lưu cụm'}
                </Button>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
      <SavePhraseForm handleAfterSuccess={handleAfterSuccess} />
    </Flex>
  )
}

export default Summary
